export default __webpack_public_path__ + "static/media/noGovernance.4fc13b46.svg";